import Vue from 'vue';
import gridProps from '@/gridProps';

import {
  formatNumber,
  autoResize,
  alignCells
} from '@/helpers/renderHelpers';
import {
  addColIdToColumns,
  handlerResponse,
  sumTotalData
} from '@/helpers/commonHelpers';
import { addComparatorsToCol } from '@/helpers/grid-helpers';


const cellStyle = (params) => {
  const numericColumns = ['width', 'length', 'thickness'];
  return alignCells(params, numericColumns.includes(params.colDef.field) && 'right');
}

export default {
  namespaced: true,
  state: {
    packets: [],
    columns: [],
    totalData: [
      {
        label: 'total_packets',
        value: 0
      },
      {
        label: 'quantity',
        value: 0,
        key: 'pieces'
      },
      {
        label: 'total_weight',
        value: 0,
        key: 'weight'
      }
    ],
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      rowGroupPanelShow: 'always',
      groupSelectsChildren: true,
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        enableValue: true,
        enableRowGroup: true,
        enablePivot: true,
        valueFormatter(params) {
          return formatNumber(params.value, null);
        },
        cellStyle,
        tooltipValueGetter(params) {
          const rowData = params.data;
          if (rowData) {
            if (rowData.raw_type === 'MOVE') {
              return 'This package is on manufacture';
            } else if (rowData.raw_type === 'CLOSE') {
              return 'This package is shipped';
            } else if (rowData.raw_type === 'STOCK') {
              return 'This package is on stock';
            }
          }
        }
      },
      getRowStyle(params) {
        const rowData = params.data;
        if (rowData) {
          if (rowData.raw_type === 'MOVE') {
            return {'background': '#ccf3cc'};
          } else if (rowData.raw_type === 'CLOSE') {
            return {'background': '#ffb2b2'};
          }
        }
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        } else {
          this.api && this.api.hideOverlay();
          this.api && this.api.showNoRowsOverlay();
        }
      },
      onGridReady() {
        if (!this.rowData.length) {
          this.api.showNoRowsOverlay();
        }
      }
    },
    gridName: ''
  },
  getters: {
    packets(state) {
      return state.packets;
    },
    columns(state) {
      return state.columns.map(item => addComparatorsToCol(item));
    },
    gridOptions(state) {
      return { ...gridProps, ...state.gridOptions };
    },
    totalData(state) {
      return state.totalData;
    }
  },
  mutations: {
    setData(state, payload) {
      state.packets = payload.data;
      state.columns = addColIdToColumns(payload.used_columns);
      state.gridName = payload.grid_name
    },
    setTotalData(state, payload) {
      state.totalData = sumTotalData(payload, state.totalData);
    }
  },
  actions: {
    loadPackets(store, payload) {
      return new Promise(resolve => {
        if (store.getters.gridOptions.api) {
          store.getters.gridOptions.api.showLoadingOverlay();
        }
        const params = {
          is_vue: true,
          ...payload
        };
        Vue.http.get('woodware/search_for_movement_data', {params})
          .then(handlerResponse)
          .then(data => {
            store.commit('setData', data);
            store.commit('setTotalData', data.data);
            resolve(data);
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/manufacture/packets/packets.js